import React from "react";

export default function HeroSection() {
	return (
		<div className="hero-card">
			<div className="hero-bg-overlay"></div>

			<img
				src="/images/heroSection/heroSection_1.png"
				alt=""
				className="hero-bg-image"
			/>

			<div className="hero-content">
				<div className="offer-chip">BEST DEAL</div>
				<h1>
					Discover amazing
					<br />
					deals nearby
				</h1>
				<div className="text-center pb-3">
					<span>
						Find the best in electronics, fashion, food, and more.
					</span>
				</div>

				<div className="explore-btn">Explore Deals</div>
			</div>
		</div>
	);
}
